module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kH2XA"))).then(() => parcelRequire('hEqeo'));